import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api.js';

// tkt-back-office's defaults (lib/queryClient.ts): a list fetched on one screen is reused for a
// minute instead of refetched; no refetch on window focus (operators tab away constantly).
// One retry, but never for answers that will not change by asking again (4xx).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (count, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return count < 1;
      },
    },
  },
});

if (import.meta.env.DEV && typeof window !== 'undefined') window.__qc = queryClient;
